module.exports = __webpack_public_path__ + "03_glasses_black.3784f865.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/03_glasses_black.png
// module id = ME2c
// module chunks = 0